import { CalendarOff } from 'lucide-react'
import { Navigate } from 'react-router'
import { RequirePermission } from '@/features/auth/guards'
import { FamilyLeavePage } from '@/pages/leave/FamilyLeavePage'
import { LeaveRequestsPage } from '@/pages/leave/LeaveRequestsPage'
import { LeaveTypesPage } from '@/pages/leave/LeaveTypesPage'
import { MyLeavePage } from '@/pages/leave/MyLeavePage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'leave',
  schoolModule: 'leave',
  routes: {
    admin: [
      {
        path: 'leave',
        element: <RequirePermission permission="leave.manage" />,
        children: [
          { index: true, element: <LeaveRequestsPage /> },
          { path: 'requests', element: <Navigate to="/admin/leave" replace /> },
          { path: 'types', element: <LeaveTypesPage /> },
        ],
      },
    ],
    staff: [
      {
        path: 'leave',
        element: (
          <RequirePermission permission="leave.request">
            <MyLeavePage />
          </RequirePermission>
        ),
      },
    ],
    family: [
      {
        path: 'leave',
        element: (
          <RequirePermission permission="leave.request">
            <FamilyLeavePage />
          </RequirePermission>
        ),
      },
    ],
  },
  nav: {
    admin: [
      {
        group: 'Operations',
        order: 30,
        item: {
          label: 'Leave',
          to: '/admin/leave',
          icon: CalendarOff,
          permission: 'leave.manage',
          children: [
            {
              label: 'Requests',
              to: '/admin/leave',
              permission: 'leave.manage',
              end: true,
              keywords: 'absence approval inbox holiday vacation',
            },
            {
              label: 'Leave types',
              to: '/admin/leave/types',
              permission: 'leave.manage',
              keywords: 'allowance sick casual',
            },
          ],
        },
      },
    ],
    staff: [
      {
        order: 40,
        item: {
          label: 'My leave',
          to: '/staff/leave',
          icon: CalendarOff,
          permission: 'leave.request',
          keywords: 'absence holiday vacation',
        },
      },
    ],
    family: [
      {
        order: 35,
        item: {
          label: 'Absence requests',
          to: '/portal/leave',
          icon: CalendarOff,
          permission: 'leave.request',
          keywords: 'leave absence permission justify',
        },
      },
    ],
  },
}
